import React from 'react';

export const TableBody = ({ children }) => {
	return <tbody className="divide-y divide-glassColor">{children}</tbody>;
};
